import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '@spartacus/core';

import { FacetListComponent } from './facet-list.component';
import { IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import { FacetModule } from '../facet/facet.module';
import { CategoryFacetComponent } from '../category-facet/category-facet.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    FacetModule,
    RouterModule,
    KeyboardFocusModule,
  ],
  declarations: [FacetListComponent, CategoryFacetComponent],
  exports: [FacetListComponent, CategoryFacetComponent],
})
export class FacetListModule {}
